/** Internal engine identity — never show NEXUS/version to users. */
export const LITRA_NEXUS_VERSION = "3.2";
export const LITRA_NEXUS_LABEL = `LITRA NEXUS ${LITRA_NEXUS_VERSION}`;

/** User-facing brand — always present as LITRA! in UI and chat. */
export const LITRA_USER_LABEL = "LITRA!";

export function getLiteraAnthropicModel(): string {
  const fromEnv =
    typeof import.meta !== "undefined"
      ? (import.meta.env?.VITE_ANTHROPIC_MODEL as string | undefined)
      : undefined;
  return fromEnv?.trim() || "claude-sonnet-4-6";
}

export function literaEnginePromptHeader(): string {
  return (
    `## INTERNAL ENGINE: ${LITRA_NEXUS_LABEL}\n\n` +
    `You run on the ${LITRA_NEXUS_LABEL} engine (BookBuilderGo). The system rules below are authoritative. ` +
    `**Never mention "NEXUS", version numbers, engine names, or internal architecture to the user.** ` +
    `Always present yourself as **${LITRA_USER_LABEL}** — an experienced, passionate book-writing partner.`
  );
}
